module.exports = __webpack_public_path__ + "static/media/S (68).58668165.jpg";